<template>
  <div></div>
</template>

<script>
export default {
  name: "LayoutFooter",
  data() {
    return {
      loaded: false
    };
  },
  metaInfo: {
    title: "Editor",
    meta: [
      {
        name: "robots",
        content: "noindex"
      }
    ]
  },
  props: {
    blok: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
